import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import {useTable} from 'components/organisms/Providers/TableProvider/TableProvider';
import StyledCollectionEntitiesViewsWrapper
  from 'components/templates/Wrappers/Collections/CollectionEntitiesViewsWrapper/CollectionEntitiesViewsWrapper.styles';
import CollectionEntitiesTableViews
  from 'components/organisms/TableViews/CollectionEntitiesTableViews/CollectionEntitiesTableViews';

const CollectionEntitiesViewsWrapper = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'CollectionEntitiesViewsWrapper');

  const tableProvider = useTable();

  return <StyledCollectionEntitiesViewsWrapper ref={ref} {...innerProps}
                                               variant="foldout"
                                               context={<CollectionEntitiesTableViews />}
                                               open={Boolean(tableProvider.state?.showViews)}
                                               size="oversize"
                                               ContextDrawerProps={{
                                                 onToggle: (e, open) => {
                                                   if (open) {
                                                     tableProvider.openViews();
                                                   } else {
                                                     tableProvider.closeViews();
                                                   }
                                                 }
                                               }}>
    {innerProps.children}
  </StyledCollectionEntitiesViewsWrapper>
});

CollectionEntitiesViewsWrapper.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default CollectionEntitiesViewsWrapper;
